// extracted by mini-css-extract-plugin
export default {"loginPage":"admin-panel_loginPage__pW8yo","login_box":"admin-panel_login_box__91c4O","background":"admin-panel_background__21Ay6","adminPanel":"admin-panel_adminPanel__Ebv0W"};